"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Converts hex color with opacity to RRGGBBAA format
 *
 * @param {string} color Color in hex with #
 * @param {number} opacity Opacity number in percent decimal
 *
 * @return {string} Value in RRGGBBAA
 */
var hexToRrggbbaa = function (color, opacity) {
    var opacityHex = Math.round(opacity * 255).toString(16); // Accounting for opacity < 10%;
    var prefixedOpacityHex = opacityHex.length > 1 ? opacityHex : "0" + opacityHex;
    return "" + color + prefixedOpacityHex;
};
exports.default = hexToRrggbbaa;
